import hfConfig from 'hfConfig';
import utils from '../shared/utils';

const headerData = {};
const flyoutVersion = hfConfig.flyoutVersion;
const privateMethods = {};
const privateData = {
  version: flyoutVersion
};
const pixelSwitchInterval = 1024;

// sets the protocol
privateMethods.determineHostName = function determineHostName() {
  return (window.location.hostname === hfConfig.secureHostName) ? hfConfig.secureHostName : hfConfig.nonSecureHostName;
};

// determines if we are in the staging LLC
privateMethods.getStagingFlag = function getStagingFlag() {
  return hfConfig.currentInstance === 's' ? '&instance=s' : '';
};

privateMethods.getFlyoutDataUrl = function _getFlyoutDataUrl() {
  const previewFlag = hfConfig.previewFlag ? 'PV-' : '';
  const hostName = privateMethods.determineHostName();

  if (THD_GLOBAL.HFAPP_useCdnFlyout) {
    let flyOutUrl = `//${hostName}/hdus/en_US/DTCCOMNEW/fetch/headerFooterFlyout-{PREVIEW}{VERSION}.json`;
    
    flyOutUrl = flyOutUrl.replace('{PREVIEW}', previewFlag);
    return flyOutUrl.replace('{VERSION}', privateData.version);
  } else {
    const stagingFlag = privateMethods.getStagingFlag();
    const versionFlag = (privateData.version ? '&version=' + previewFlag + privateData.version : '');

    return `//${hostName}/hf/rs/staticFly/headerFooterFlyout?env=&pro=false&secureClient=false${stagingFlag}${versionFlag}`;
  }
};

privateMethods.createLevel3Key = function _createLevel3Key(level1Name, level2Name) {
  return [level1Name, level2Name].join(':');
};

privateMethods.cacheLevel3Data = function _cacheLevel3Data(level1Name, level2Name, level3Data) {
  const cacheKey = privateMethods.createLevel3Key(level1Name, level2Name);

  privateData.level3[cacheKey] = level3Data;
};

privateMethods.cacheLevel1Data = function _cacheLevel1Data(completeData) {
  privateData.level1['Categories'] = [];

  completeData.forEach((item) => {
    const disableL1 = (typeof item.hide !== 'undefined') ? item.hide : false;
    // Push the token into the current array
    privateData.level1['Categories'].push({
      name: item.title,
      link: item.link,
      hideL1: disableL1,
      activeHolidayClass: item.activeHolidayClass,
      feature: item.feature
    });
  })
};

// Most of this work could be a map, but support isn't there yet
privateMethods.cacheLevel2DataV6 = function _cacheLevel2DataV6(categoryName, completeData) {
  let currentCategory;

  privateData.level2[categoryName] = [];

  for (let index = 0; index < completeData.length; index++) {
    currentCategory = completeData[index];

    // Push the token into the current array
    privateData.level2[categoryName].push({
      name: currentCategory.name,
      url: currentCategory.url
    });

    // Cache the next level
    privateMethods.cacheLevel3Data(categoryName, currentCategory.name, currentCategory.l3);
  }
};
privateMethods.cacheLevel2DataV8 = function _cacheLevel2DataV8(completeData) {
  let currentCategory;

  privateData.level2[completeData.title] = [];
  // completeData = (typeof completeData.l2 !== 'undefined') ? completeData.L2 : completeData;
  for (let index = 0; index < completeData.l2.length; index++) {
    currentCategory = completeData.l2[index];

    // Push the token into the current array
    privateData.level2[completeData.title].push({
      name: currentCategory.name,
      url: currentCategory.url
    });

    // Cache the next level
    privateMethods.cacheLevel3Data(completeData.title, currentCategory.name, currentCategory.l3);
  }
};

privateMethods.clearCachedData = function _clearCachedData() {
  privateData.level1 = {};
  privateData.level2 = {};
  privateData.level3 = {};
};

privateMethods.cacheData = function _cacheData(data) {
  const responseData = (flyoutVersion === '6') ? data : data.header.primaryNavigation;
  // Clear cache
  privateMethods.clearCachedData();
  // check the version to loop L1
  if (flyoutVersion === '8') {
    privateMethods.cacheLevel1Data(responseData);
    responseData.forEach((item) => {
      privateMethods.cacheLevel2DataV8(item);
    })
  } else {
    // Loop over the data
    responseData.forEach((item) => {
      privateMethods.cacheLevel2DataV6(item);
    })
  }

  return privateData;
};

privateMethods.requestData = function _requestData(ajaxUrl) {
  if (THD_GLOBAL.HFAPP_useCdnFlyout) {
    return utils.fetchWithTimeout(ajaxUrl, { timeout:3000 }).then( res => res.json() );
  } else {
    return new Promise(function(resolve, reject) {
      const callbackName = 'staticFlyCallback';
      window[callbackName] = function(data) {
        delete window[callbackName];
        resolve(data);
      }
      const src = `${ajaxUrl}&callback=${callbackName}`;
      let script = document.createElement('script');
      script.src = src;
      document.querySelector('head').appendChild(script);
    });
  }
};

/** the method was only for testing locally
 privateMethods.requestDataFly = function _requestDataFly() {
  return $.getJSON("headerFooterData.json", function(json){
  });
}; **/

// Async fetch of the L1-L2-L3 JSON from the header app
privateMethods.loadFlyoutData = function loadFlyoutData() {
  const loadDataDefer = utils.deferred();
  const dataUrl = privateMethods.getFlyoutDataUrl();
  let ajaxRequest = privateMethods.requestData(dataUrl);

  if (THD_GLOBAL.HFAPP_useCdnFlyout) {
    ajaxRequest = ajaxRequest.then(function (response) {
      const replacedJson = JSON.stringify(response)
        .replace(/NON_SECURE/g, hfConfig.nonSecureHostName)
        .replace(/SECURE_SUPPORTED/g, '//' + hfConfig.nonSecureHostName)
        .replace(/SECURE/g, 'https://' + hfConfig.secureHostName);

      return JSON.parse(replacedJson);
    });
  }

  ajaxRequest
    .then(privateMethods.cacheData)
    .then(loadDataDefer.resolve);

  ajaxRequest.catch(function _ajaxRequestFailure() {
    loadDataDefer.reject('Failed to load flyout data.');
  });

  return loadDataDefer.promise();
};

privateMethods.initialize = function initialize() {
  if (!privateData.dataLoaded) {
    // initialize cache
    privateMethods.clearCachedData();

    // load the data
    privateData.dataLoaded = privateMethods.loadFlyoutData();
  }

  return privateData.dataLoaded;
};

privateMethods.getBreakpointFromWidth = function _getBreakpointFromWidth(currentWidth) {
  let result = 'default';

  if (currentWidth >= 1440) {
    result = 'lg';
  } else if (currentWidth >= 1280) {
    result = 'md';
  } else if (currentWidth >= 1024) {
    result = 'sm';
  } else if (currentWidth >= 640) {
    result = 'xs';
  }

  return result;
};

privateMethods.checkForBreakpointChange = function _checkForBreakpointChange() {
  const windowWidth = window.innerWidth;
  const currentBreakpoint = privateMethods.getBreakpointFromWidth(windowWidth);

  if (privateData.breakpoint !== currentBreakpoint) {
    document.dispatchEvent(new CustomEvent('breakpointChanged', {
      detail: {
        old: privateData.breakpoint,
        new: currentBreakpoint
      }
    }));
  }

  privateData.breakpoint = currentBreakpoint;
};

privateMethods.getEtchJSON = function _getEtchJSON(jsonPath) {
  const loadDataDefer = utils.deferred();

  const hostName = privateMethods.determineHostName();
  const ajaxUrl = '//' + hostName + jsonPath;

  fetch(ajaxUrl, {
    headers: {	
      'Accept': 'application/json'	
    },	
  }).then((response) => {	
    if (!response.ok) {	
      throw new Error('Failed to load flyout data');	
    }	
    return response.json()	
  })
    .then((data) => {loadDataDefer.resolve(data)})
    .catch(() => {loadDataDefer.reject('Failed to load flyout data')});

  return loadDataDefer.promise();
};

/*
 * Public Methods
 */
headerData.init = function init() {
  /* Events
  ------------------------------------------------ */
  headerData.loaded = privateMethods.initialize();

  window.addEventListener('resize', privateMethods.checkForBreakpointChange);

  return headerData.loaded;
};

headerData.checkEventBus = function checkEventBus() {
  return (typeof window !== 'undefined' && (window.THD_EVENT_BUS || window.LIFE_CYCLE_EVENT_BUS));
};

headerData.isSurfacePro = function isSurfacePro() {
  if (!(navigator.userAgent).match(/Edge/g)) {
    return (navigator.userAgent.match(/Edge/g) !== null);
  }
  return false;
};

headerData.getMenuConfig = function getMenuConfig() {
  // config the different flyouts here
  return {
    'departmentsFlyout': {
      'name': 'departmentsFlyout',
      'menuClass': 'MainFlyout',
      'isActive': false
    },
    'homeDecorFurniture': {
      'name': 'homeDecorFurniture',
      'menuClass': 'homeDecorFurnitureFlyout',
      'isActive': false
    },
    'diyProjectsIdeas': {
      'name': 'diyProjectsIdeas',
      'menuClass': 'diyFlyout',
      'isActive': false
    },
    'homeServices': {
      'name': 'homeServices',
      'menuClass': 'hsFlyout',
      'isActive': false
    },
    'specialOffers': {
      'name': 'specialOffers',
      'menuClass': 'specialOffersFlyout',
      'isActive': false
    }
  };
};

headerData.isDropDown = function isDropDown() {
  const hostName = window.location.hostname;
  const host = privateMethods.determineHostName();
  const localHost = 'localhost.homedepot.com'; // I'm checking against localhost since we can use cors plugin for dev
  return hostName === localHost || hostName === host;
};

headerData.getEtchJSON = function getEtchJSON(url) {
  const loadDataDefer = utils.deferred();
  const getEtchDataPromise = privateMethods.getEtchJSON(url);

  getEtchDataPromise.then(function (data) {
    loadDataDefer.resolve(data);
  }, () => {});

  return loadDataDefer.promise();
};

headerData.getHostName = function getHostName() {
  return privateMethods.determineHostName();
};

headerData.isNotThirdParty = headerData.isDropDown;

headerData.isSmallWidth = function isSmallWidth() {
  return window.innerWidth < pixelSwitchInterval;
};

headerData.isCartPage = function isCartPage(url) {
  return url.indexOf('/mycart/home') !== -1;
};
headerData.isThankYouPage = function isThankYouPage(url) {
  return url.indexOf('/mycheckout/thankyou#') !== -1;
};

headerData.getPrivateMethods = function getPrivateMethods() {
  return privateMethods;
};

headerData.getPrivateData = function getPrivateData() {
  return privateData;
};

// if you are a touch device
headerData.isTouchDevice = function isTouchDevice() {
  return !(!('ontouchstart' in window) && !window.navigator.msMaxTouchPoints && !window.navigator.userAgent.toLowerCase().match(/windows phone os 7/i));
};

headerData.getLevel3Key = function _getLevel3Key() {
  const args = Array.prototype.slice.call(arguments);
  return privateMethods.createLevel3Key.apply(null, args);
};

headerData.getLevel1Data = function _getLevel1Data() {
  const dataDefer = utils.deferred();

  // If Load started
  if (privateData.dataLoaded) {
    // Wait for load to complete
    privateData.dataLoaded.then(function _level1DataLoaded() {
      // check for the value
      if (privateData.level1['Categories'] && privateData.level1['Categories'].length) {
        // return it
        dataDefer.resolve(privateData.level1['Categories']);
        // This looks like a failure to load data
      } else {
        dataDefer.reject('Could not find level 1 value in Categories');
      }
    });

    // Not loaded yet
  } else {
    dataDefer.reject('Data is not loaded');
  }

  return dataDefer.promise();
};

headerData.getLevel2Data = function _getLevel2Data(level1Name) {
  const dataDefer = utils.deferred();

  // If Load started
  if (privateData.dataLoaded) {
    // Wait for load to complete
    privateData.dataLoaded.then(function _level2DataLoaded() {
      // check for the value
      if (privateData.level2[level1Name] && privateData.level2[level1Name].length) {
        // return it
        dataDefer.resolve(privateData.level2[level1Name]);
        // This looks like a failure to load data
      } else {
        dataDefer.reject('Could not find level 2 value for "' + level1Name + '"');
      }
    });

    // Not loaded yet
  } else {
    dataDefer.reject('Data is not loaded');
  }

  return dataDefer.promise();
};

headerData.getLevel3Data = function _getLevel3Data(level1Name, level2Name) {
  const dataDefer = utils.deferred();
  const cacheKey = privateMethods.createLevel3Key(level1Name, level2Name);

  // If Load started
  if (privateData.dataLoaded) {
    // Wait for load to complete
    privateData.dataLoaded.then(function _level3DataLoaded() {
      // check for the value
      if (privateData.level3[cacheKey] && privateData.level3[cacheKey].length) {
        // return it
        dataDefer.resolve(privateData.level3[cacheKey]);
        // This looks like a failure to load data
      } else {
        dataDefer.reject('Could not find level 3 value for "' + level1Name + '" and "' + level2Name + '"');
      }
    });

    // Not loaded yet
  } else {
    dataDefer.reject('Data is not loaded');
  }

  return dataDefer.promise();
};

export default headerData;